import React from 'react';
import Button from '../../components/Button/Button';

import eye from '../../brand/generated/popover/eye.svg';
import bucket from '../../brand/generated/popover/delete.svg';
import edit from '../../brand/generated/popover/edit.svg';
import set from '../../brand/generated/popover/set.svg';

export const ASSIGN_TITLE = 'Назначить ответственного';

const POPOVER = [
  { title: 'Просмотреть лид', icon: eye },
  { title: 'Редактировать лид', icon: edit },
  { title: ASSIGN_TITLE, icon: set },
  { title: 'Удалить лид', icon: bucket },
];

/** Меню строки списка лидов. Рядовой менеджер лиды не раздаёт — «Назначить» ему не показываем. */
export const leadPopover = (isManager) => (isManager ? POPOVER.filter((item) => item.title !== ASSIGN_TITLE) : POPOVER);

// Фон и отступы задаём тут: `.table td button` сбрасывает их у любой кнопки в ячейке,
// и белый текст «Принять» оставался на розовой строке без подложки.
const acceptButtonStyle = {
  backgroundColor: 'var(--brand-primary)',
  padding: '6px 14px',
  fontSize: 12,
  lineHeight: '16px',
  minHeight: 0,
  height: 'auto',
};

/**
 * Лид без ответственного: в колонке «Менеджер» вместо пустоты — кнопка приёма.
 * onAccept читается в момент клика (через функцию), чтобы не пересоздавать колонки
 * на каждый рендер списка.
 */
export const withAcceptCell = (columns, getOnAccept) =>
  columns.map((column) =>
    column.Header === 'Менеджер'
      ? {
          ...column,
          Cell: ({ row }) =>
            row.original.manager?.fullName || (
              <Button text="Принять" fill style={acceptButtonStyle} onClick={() => getOnAccept()(row.original)} />
            ),
        }
      : column
  );
